// All value valid for fontSize: 10px

export default {
    data: {
        A: {
            width: 6.4
        },
        B: {
            width: 6.5
        },
        C: {
            width: 6.4
        },
        E: {
            width: 5.6
        },
        F: {
            width: 5.2
        },
        G: {
            width: 7.3
        },
        H: {
            width: 7.4
        },
        I: {
            width: 2.8
        },
        J: {
            width: 2.7
        },
        K: {
            width: 6.2
        },
        L: {
            width: 5.2
        },
        M: {
            width: 7.4
        },
        N: {
            width: 7.6
        },
        O: {
            width: 7.8
        },
        P: {
            width: 6.1
        },
        Q: {
            width: 7.8
        },
        R: {
            width: 6.2
        },
        S: {
            width: 5.5
        },
        T: {
            width: 5.6
        },
        U: {
            width: 7.3
        },
        V: {
            width: 6
        },
        W: {
            width: 9.3
        },
        X: {
            width: 5.8
        },
        Y: {
            width: 5.7
        },
        Z: {
            width: 5.8
        },
        a: {
            width: 5.6
        },
        b: {
            width: 6.14
        },
        c: {
            width: 4.8
        },
        e: {
            width: 5.7
        },
        f: {
            width: 3.4
        },
        g: {
            width: 5.5
        },
        h: {
            width: 6.2
        },
        i: {
            width: 2.6
        },
        j: {
            width: 2.6
        },
        k: {
            width: 5.3
        },
        l: {
            width: 2.6
        },
        m: {
            width: 9.4
        },
        n: {
            width: 6.2
        },
        o: {
            width: 6.1
        },
        p: {
            width: 6.2
        },
        q: {
            width: 6.2
        },
        r: {
            width: 4.1
        },
        s: {
            width: 4.8
        },
        t: {
            width: 3.6
        },
        u: {
            width: 6.2
        },
        v: {
            width: 5.1
        },
        w: {
            width: 7.8
        },
        x: {
            width: 5.3
        },
        y: {
            width: 5.1
        },
        z: {
            width: 4.7
        },
        0: {
            width: 5.8
        },
        1: {
            width: 5.8
        },
        2: {
            width: 5.8
        },
        3: {
            width: 5.8
        },
        4: {
            width: 5.8
        },
        5: {
            width: 5.8
        },
        6: {
            width: 5.8
        },
        7: {
            width: 5.8
        },
        8: {
            width: 5.8
        },
        9: {
            width: 5.8
        },
        '-': {
            width: 2.22
        },
        ' ': {
            width: 2.61
        },
        '›': {
            width: 3.15
        },
        '(': {
            width: 2.97
        },
        ')': {
            width: 2.97
        },
        '=': {
            width: 5.72
        },
        '@': {
            width: 9
        }
    }
};



// WEBPACK FOOTER //
// ./app/services/chars/chars.config.js